<div
  class="ui-code-input"
  [class.ui-code-input--invalid]="invalid()"
  [class.ui-code-input--disabled]="disabled()"
>
  @if (showHeader()) {
    <div class="ui-code-input__header">
      <label class="ui-code-input__label" [attr.for]="groupId()">{{
        label()
      }}</label>
      @if (showRequirement()) {
        <span
          class="ui-code-input__requirement"
          [class.ui-code-input__requirement--error]="invalid() && required()"
          aria-hidden="true"
        >
          {{ requirementText() }}
        </span>
      }
    </div>
  }

  <div
    class="ui-code-input__boxes"
    role="group"
    [id]="groupId()"
    [attr.aria-label]="label() || 'Código'"
    [attr.aria-invalid]="invalid() || null"
    [attr.aria-describedby]="visibleMessage() ? messageId() : null"
  >
    @for (digit of cells(); track $index) {
      <input
        #cell
        class="ui-code-input__cell"
        type="text"
        inputmode="numeric"
        autocomplete="one-time-code"
        maxlength="1"
        [value]="digit"
        [disabled]="disabled()"
        [attr.aria-label]="'Dígito ' + ($index + 1)"
        (input)="onCellInput($index, $event)"
        (keydown)="onCellKeydown($index, $event)"
        (paste)="onCellPaste($index, $event)"
        (focus)="onCellFocus($event)"
      />
    }
  </div>

  @if (visibleMessage()) {
    <p
      class="ui-code-input__message"
      [class.ui-code-input__message--error]="invalid()"
      [id]="messageId()"
    >
      {{ visibleMessage() }}
    </p>
  }
</div>
